import { Injectable } from '@angular/core';

import { NotificationPermission } from 'common/enums';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotificationGuideComponent } from '../components/notification-guide/notification-guide.component';


@Injectable({
  providedIn: 'root'
})
export class AllowNotificationService {
  public permission: NotificationPermission = NotificationPermission.ask;
  private donotShowKey = 'dontShowNotificationCustomAlert';
  modalRef?: BsModalRef;

  constructor(private modalService: BsModalService,) { }

  checkForNotification() {
    const notCustomPopup = localStorage.getItem(this.donotShowKey) === 'true';

    // Let's check if the browser supports notifications
    if (!('Notification' in window)) {
      console.warn('This browser does not support desktop notification');
    }
    // Let's check whether notification permissions have already been granted
    else if (Notification.permission === NotificationPermission.granted) {
      this.permission = NotificationPermission.granted;
    }
    // Otherwise, we need to ask the user for permission
    else if (Notification.permission !== NotificationPermission.denied) {
      if (!notCustomPopup) {
        this.showNotificationGuide();
      }
      this.requestPermission();
    } else {
      this.permission = NotificationPermission.denied;
      if (!notCustomPopup) {
        this.showNotificationGuide();
      }
      console.warn('Notification setting is denied.');
    }
  }

  private requestPermission() {
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === NotificationPermission.granted) {
        //this.dialog.closeAll();
        this.permission = NotificationPermission.granted;
        new Notification('Your notifcation setting is enabled now. You will receive important updates via notifications.');
      } else if (permission === NotificationPermission.denied) {
        this.permission = NotificationPermission.denied;
      }
    });
  }

  public showNotificationGuide() {
    this.modalRef = this.modalService.show(NotificationGuideComponent);
    this.modalRef.content.allowNotificationResult.subscribe((response: any) => {
      if (response) {
        localStorage.setItem(this.donotShowKey, 'true');
      }
    });
  }
}
